"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(name, index) {
    return ['FT.ALIASDEL', name, index];
}
exports.transformArguments = transformArguments;
